/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { empty, errorResponse, floatval, isArray, isObject, isString, prepareResponseData, toAmountFormat } from "../../Utilities/utils";
import { Toast } from "primereact/toast";

// css
import "../students/Students.css";
import "./PaymentInvoice.css";

// images
import appLogo from "../../assets/logo/blue-logo.png"

// api
import paymentApi from "../../api/Payment";

// components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import FullPageLoader from "../../components/loader/FullPageLoader";
import { AuthContext } from "../Root/ProtectedRoute";
import PaymentWrapper from "../../components/appWrapper/PaymentWrapper";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import colors from "../../config/colors";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import { FaCheck, FaPrint, FaTimes } from "react-icons/fa";

const PaymentInvoice = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const { invoiceId } = useParams();
  const toastTR = useRef(null);
  const toast = useRef(null);
  const printRef = useRef();
  const [ accountDetails, setAccountDetails ] = useState([]);

  const [student, setStudent] = useState([]);
  const [fees, setFees] = useState([]);
  const [ invoiceData, setInvoiceData ] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [feePayableDetails, setFeePayableDetails] = useState([]);

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    getInvoiceDetails();
    setAccountDetails(user?.bankAccounts || []);
  }, []);

  useEffect(() => {
    
  }, [feePayableDetails]);
  const printReport = () => {
    window.print();
  };

  /**
   * Get fee details
   * @returns 
   */
  const getInvoiceDetails = async () => {
    if (!isLoading) setIsLoading(true);
    try {
      const response = await paymentApi.getInvoiceDetails(invoiceId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Failed to get fee details."
        );
      }

      const data = isObject(response_data?.response) ? response_data.response : {};
      setFeePayableDetails(isArray(data.invoiceDetails) ? data?.invoiceDetails : []);
      setStudent(isObject(data?.studentData) ? data.studentData : {} );
      setInvoiceData(isObject(data?.invoiceData) ? data.invoiceData : {});
      setFees(isArray(data?.fees) ? data.fees : [])
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Handle submission
   * @param values
   */
  const completePayment = async (action) => {
    if (!isLoading) setIsLoading(true);
    try {
      if (empty(action)) {
        return responseDialog(
          "error",
          "Internal server error!",
          "Something went wrong! Refresh the page or try again later."
        );
      }
      const response = await paymentApi.completePayment({ action, invoice_id: invoiceId });
      const response_data = prepareResponseData(response);
      if (!response_data?.success) {
        return responseDialog(
          "error",
          "Error Alert",
          isString(response_data?.response)
            ? response_data.response
            : "Something went wrong!"
        );
      }
      
      responseDialog("success", "Payment Recorded", "Payment has been recorded successfully.");
      return setTimeout(() => {
        window.location.reload();
      }, 2000)
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  const descriptionTemplate = (rowData) => {
    try {
      return (
        <div>
          <div>
            {rowData?.categoryTitle || ''}
          </div>
          <div className="fs-12 mt-5">({ rowData?.sessionTitle || '' }/{ rowData?.termTitle || '' })</div>
        </div>
      )
    } catch (error) {}
  }

  return (
    <>
      <PaymentWrapper {...props}>
        <main>
          <div className="container flex-center-top">
            <MainHeader
              title="Payment Invoice"
            />
            <div className="invoice-page-container">
              <div className="flex flex-end mb-20" style={{ width: "80%" }}>
                <ButtonIcon
                  height={45}
                  marginTop={2}
                  color={colors.primary}
                  backgroundColor={colors.white}
                  width={160}
                  borderColor={colors.primary}
                  buttonText={<div><FaPrint /> Print {invoiceData?.status?.toLowerCase() === 'completed' ? 'Receipt' : "Invoice"}</div>}
                  type="submit"
                  borderHover={false}
                  onClick={() => printReport()}
                />
              </div>
              <div className="invoice-sheet-display">
                <div className="invoice-body" ref={printRef}>
                  <div className="invoice-header">
                    <div className="school-logo">
                      <img src={user?.avatar || appLogo || ''} alt="" />
                    </div>
                    <div className="invoice-title"><span>{invoiceData?.status?.toLowerCase() === 'completed' ? 'RECEIPT' : "INVOICE"}</span></div>
                  </div>

                  <div className="invoice-details fs-14">
                    <div className="invoice-left-top">
                      <div className="invoice-item-title">{invoiceData?.status?.toLowerCase() === 'completed' ? 'Receipt' : "Invoice"} for:</div>
                      <div className="invoice-item-detail big-title">{ student?.fullName || ''}</div>
                      <div className="mt-10">
                        <div className="invoice-item-title">Payment for:</div>
                          {
                            feePayableDetails?.map((fee, index) => {
                              return (
                                <div key={index} className="invoice-item-detail">
                                  {fee?.title || ''}
                                </div>
                              )
                            })
                          }
                      </div>
                      <div className="mt-10">
                        <div className="invoice-item-title">Payment Status:</div>
                          <div className="bold fs-16" style={{ color: invoiceData?.status?.toLowerCase() === 'pending' ? colors.tomato : invoiceData?.status?.toLowerCase() === 'completed' ? colors.success : colors.danger }}>
                            {invoiceData?.status || ''}
                        </div>
                      </div>
                      {invoiceData?.status?.toLowerCase() === 'completed' &&
                        <div className="mt-10">
                          <div className="invoice-item-title">All Debt Status:</div>
                          <div className="invoice-item-detail bold fs-16" style={{ color: invoiceData?.paymentCompleted ? colors.success : colors.tomato }}>
                              {invoiceData?.paymentCompleted ? 'Debts Cleared' : 'Outstanding Debts'}
                          </div>
                        </div>
                      }
                    </div>
                    <div className="invoice-right-top">
                      <div className="mb-10">
                        <div className="invoice-item-title">{invoiceData?.status?.toLowerCase() === 'completed' ? 'Receipt' : "Invoice"} No:</div>
                        <div className="invoice-item-detail">{invoiceData?.invoiceNumber || ''}</div>
                      </div>
                      <div className="mb-10">
                        <div className="invoice-item-title">Date:</div>
                        <div className="invoice-item-detail">{ invoiceData?.paymentDate || '' }</div>
                      </div>
                      <div className="mb-10">
                        <div className="invoice-item-title">Due:</div>
                        <div className="invoice-item-detail big-title">{ user?.currency?.currency_symbol || ""}{toAmountFormat(invoiceData?.amountPaid || 0)}</div>
                      </div>
                    </div>
                  </div>

                  <div className="invoice-description mt-20 fs-14">
                    <Toast ref={toast} />
                    <DataTable value={fees || []} tableStyle={{ maxWidth: '100%', fontSize: 14 }}>
                      <Column field="categoryTitle" header="Description" body={descriptionTemplate} 
                          style={{ width: "35%" }} />
                      <Column field="amount" header="Amount Due" style={{ width: "15%" }} body={(rowData) => {
                        return (
                          <div>{ user?.currency?.currency_symbol || ""}{toAmountFormat(rowData?.amount_due || 0)}</div>
                        )
                      }} />
                      <Column field="amount" header="Amount Paid" style={{ width: "15%" }} body={(rowData) => {
                        return (
                          <div>{ user?.currency?.currency_symbol || ""}{toAmountFormat(rowData?.amountPaid || 0)}</div>
                        )
                      }} />
                      <Column field="amount" header="Balance" style={{ width: "15%" }} body={(rowData) => {
                        return (
                          <div>{ user?.currency?.currency_symbol || ""}{toAmountFormat(rowData?.balance || 0)}</div>
                        )
                      }} />
                        <Column field="total" header="Total" style={{ width: "25%" }} body={(rowData) => {
                        return (
                          <div>{user?.currency?.currency_symbol || ""}{toAmountFormat(floatval(rowData?.amountPaid - 0) || 0)}</div>
                        )
                      }} />
                    </DataTable>
                  </div>

                  <div className="payment-details">
                    <div className="mb-20">
                      <div className="invoice-item-title">Send payment to:</div>
                      {
                        accountDetails?.map((account, index) => {
                          return (
                            <div key={account?.id || index} className="payment-detail send-to-payment">
                              <div className="account-details">
                                <div>Bank Name: </div>
                                <div className="invoice-item-detail fs-14">{account?.name || ''}</div>
                              </div>
                              <div className="account-details">
                                <div>Account Name: </div>
                                <div className="invoice-item-detail fs-14">{account?.accountName || ''}</div>
                              </div>
                              <div className="account-details">
                                <div>Account Number: </div>
                                <div className="invoice-item-detail fs-14">{account?.accountNumber || ''}</div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                    <div className="total-due">
                      <div className="account-details total-due-pad mb-10">
                        <div className="flex flex-end">Sub-total: </div>
                        <div>{user?.currency?.currency_symbol || ""}{toAmountFormat(invoiceData?.amountPaid || 0)}</div>
                      </div>
                      <div className="account-details total-due-pad mb-10">
                        <div className="flex flex-end">Tax: </div>
                        <div>{ user?.currency?.currency_symbol || ""}{toAmountFormat(0)}</div>
                      </div>
                      <div className="account-details total-due-pad mb-10">
                        <div className="flex flex-end">Charge: </div>
                        <div>{ user?.currency?.currency_symbol || ""}{toAmountFormat(0)}</div>
                      </div>
                      <div className="account-details total-due-pad total-box mb-10">
                        <div className="flex flex-end">Total: </div>
                        <div>{ user?.currency?.currency_symbol || ""}{toAmountFormat(invoiceData?.amountPaid || 0)}</div>
                      </div>
                    </div>
                  </div>

                  {invoiceData?.status?.toLowerCase() === 'completed' && invoiceData?.amountSpillOver > 0 ?
                    <div className="mt-20">
                      <div className="appr-text fs-14"><strong className="text-danger">Note: </strong>You have a spillover balance of &nbsp;<strong>{ user?.currency?.currency_symbol || ""}{ toAmountFormat(invoiceData?.amountSpillOver)}</strong>. This balance will be added to your wallet and you can use it to offset future fees/debts.</div>
                    </div> : <div></div>
                  }

                  <div className="invoice-footer mt-20">
                    <div className="appreciation">
                      <div className="mb-10 appr-text">
                        Thank you for your payment
                      </div>
                      <div className="mb-5">{ user?.name || user?.abbr?.toUpperCase() || ''}</div>
                      <div className="mb-5">({ user?.phoneNumber1 || user?.phoneNumber1 || user?.ownerPhone || ''})</div>
                      <div className="mb-5">({ user?.email || user?.ownerEmail || ''})</div>
                    </div>
                    <div className="burser">
                      <div className="mgt">Mgt:</div>
                      <div className="mt-10">
                        {user?.ownerName || ''}
                      </div>
                    </div>
                  </div>

                  {invoiceData?.status?.toLowerCase() === 'pending' &&
                    <div className="invoice-action exclude-print">
                      <ButtonIcon
                        backgroundColor={colors.danger}
                        color={colors.white}
                        icon={<FaTimes />}
                        buttonText="Cancel Payment"
                        borderColor={colors.danger}
                        onClick={() => completePayment('complete')}
                        iconMarginRight={9}
                      />
                      <ButtonIcon
                        backgroundColor={colors.primary}
                        color={colors.white}
                        icon={<FaCheck />}
                        buttonText="Complete Payment"
                        borderColor={colors.primary}
                        onClick={() => completePayment('complete')}
                        marginRight={1}
                        iconMarginRight={9}
                      />
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </main>
        {isLoading && <FullPageLoader visible={isLoading} />}
        <Toast ref={toastTR} position="bottom-left" />
      </PaymentWrapper>
    </>
  );
};

export default PaymentInvoice;
